<template>
  <li class="list-group-item kit-item mb-3 p-0" v-bind:class="className">
    <div class="invalidKit" v-if="isInvalidated">
      <div class="invalidKitLabel">This kit has been invalidated.</div>
    </div>
    <div class="p-2 rowA">
      <div class="row mt-2 pb-2">
        <!-- Kit date editName/Add notes section-->
        <div class="col-lg-3 col-12 pt-2 mb-md-0 mb-4">
          <div
          style="padding-left:20px; min-height:148px"
          class="d-flex flex-column justify-content-between text-center">
            <div class="row d-lg-none">
              <div class="col-12" style="height:40px;">
                <kit-timeline
                  :kit="kit"
                  :compactView="true"
                  v-if="kit"
                  :baseStatus="baseStatus"
                  :overrideStatuses="overrideStatuses"
                ></kit-timeline>
              </div>
            </div>
            <div class="row mb-3 d-lg-none">
              <div class="col-12">
                <a
                  href="#"
                  class="btn-link-blue d-block"
                  :id="`timelineTop` + kit.id"
                  @click.prevent
                >View kit progress</a>
              </div>
            </div>
            <h2 style="font-size: 24px; display:block">{{ kit.name || dateString }}</h2>
            <router-link
            v-if="this.kit.sampleStatus === 'RESULTS_AVAILABLE' && !isInfantKit"
            :to="reportLink"
            class="my-4 mx-auto w-75 btn btn-sm btn-outline-light">View Report</router-link>
            <a :id="`notes` + kit.id" @click.prevent="" href="#" class="pb-0 btn-link-blue"><i class="fas fa-edit"></i> Edit name / Add notes</a>
          </div>
        </div>
        <!-- Main kit status section -->
        <div
          v-if="kit.kitStatus !== 'UNASSIGNED' && kit.kitStatus !== 'ASSIGNED'"
          class="col-lg-9 col-12 pt-2 pb-2 pl-4 text-right"
        >
          <div class="pr-md-4">
            <div
              class="stat-group d-flex stat-group d-flex flex-column align-items-end"
              v-if="!isInfantKit"
            >
              <div class="stat-group-inner row d-lg-flex flex-lg-nowrap">
                <SurveyStat
                  v-for="stat in surveyStats"
                  :key="stat.surveyType"
                  showCoach="false"
                  :stat="stat"
                  :kitId="kit.id"
                ></SurveyStat>
                <CoachState
                  :kit="kit"
                  :unlocked="unlocked"
                  v-if="kit.sampleStatus==='RESULTS_AVAILABLE' && kit.kitStatus!=='invalidated' && showCoach"
                ></CoachState>
              </div>
            </div>
            <div v-else>
              <button
                @click.prevent="openQuestionnaire"
                class="btn btn-primary col-lg-4 offset-lg-8 col-12 mt-4"
              >Open Questionnaires</button>
              <router-link
                :to="reportLink"
                v-if="this.kit.sampleStatus === 'RESULTS_AVAILABLE'"
                class="btn btn-outline-light col-lg-4 offset-lg-8 col-12 btn-block mt-2"
              >View Report</router-link>
            </div>
          </div>
        </div>
        <div v-else class="col-lg-4 offset-lg-5 col-12 pl-4 text-right">
          <div class="d-flex align-items-start flex-column bd-highlight h-100">
            <div class="mb-auto mt-auto w-100">
              <button
                v-if="!isClientManagedResearchKit"
                class="btn btn-primary btn-green"
                v-on:click="onClickSend"
              >Send this kit to me now</button>
            </div>
            <div class="mb-auto mt-auto w-100" v-if="allowGive">
              <button class="btn btn-outline-blue" v-on:click="onClickGive">Give this kit to someone</button>
            </div>
          </div>

          <!--<div class="mb-3 buttons" v-if="this.kit.sampleStatus === 'RESULTS_AVAILABLE'">-->
          <!--<router-link :to="reportLink" class="btn btn-outline-light">View Report</router-link>-->
          <!--</div>-->
          <!--<div class="mb-3 buttons" v-else-if="requestedReplacement">-->
          <!--<button class="btn btn-primary" v-on:click="onClickReplacement">Order replacement</button>-->
          <!--</div>-->
          <!--<div v-else-if="notActivated" class="d-flex flex-row">-->
          <!--<div class="buttons ">-->
          <!--<button class="btn btn-primary" style="background-color: #5CD69F; border:none" v-on:click="onClickActivate">Send this kit to me now</button>-->
          <!--</div>-->
          <!--<div class="buttons ">-->
          <!--<button class="btn btn-primary" style="background:none; border: 1px solid #3F9FCF; color: #3F9FCF" v-on:click="onClickActivate">Give this kit to someone</button>-->
          <!--</div>-->
          <!--</div>-->
        </div>

      </div>
    </div>
    <div class="p-2 rowB">
      <div class="row no-gutters pt-2 pb-2 pl-3" style="font-weight:400">
        <div class="col-12 col-lg d-none d-lg-block pt-2">
          <div class="timelineCell d-block" style="width:260px; height:30px; float:left">
            <kit-timeline
              :kit="kit"
              :compactView="true"
              v-if="kit"
              :baseStatus="baseStatus"
              :overrideStatuses="overrideStatuses"
            ></kit-timeline>
          </div>
          <div class="d-block" style="float:left">
            <a
              href="#"
              class="btn-link-blue btn-timeline"
              :id="`timelineBottom` + kit.id"
              @click.prevent
            >View kit progress</a>
          </div>
        </div>

        <div class="col-12 col-lg-7">
          <div  class="row no-gutters">
            <div class="col-12 text-center text-md-right mb-2 mb-md-0 sampleCodeCell d-flex flex-row justify-content-between">
              <div class="d-flex flex-column text-left">
                <span v-if="kit.voucherCode" class="">Voucher Code: {{ kit.voucherCode }}</span>
                <span v-if="kit.sampleIdentifier" class="">Sample ID: {{ kit.sampleIdentifier }}</span>
              </div>
              <div>
                <span v-if="kit.referralCode" class="pr-2">Referral Code: REF{{ kit.referralCode }}</span>
                <span v-if="kit.referralCode">
                <span v-if="applingReferral">
                  <i class="fas fa-spinner fa-spin"></i>
                </span>
                <a v-else href="#" @click.prevent="removeReferral" class="btn-blue btn-link-blue text-bold mr-2" >Remove</a>
                </span>
              </div>
            </div>
            <div v-show="!kit.referralCode && showReferralCode" class="col-12 col-lg-9">
              <div>
                <input
                  v-model="referralCode"
                  class="w-100 pracCode"
                  :placeholder="shortPHPrac"
                  @focus="hidePlaceholder = true"
                  @blur="hidePlaceholder = false"
                />
                <!--<input v-model="referralCode" class="w-100 pracCode" :placeholder="fullPHPrac" @focus="hidePlaceholder = true" @blur="hidePlaceholder = false"/>-->
                <a
                  href="#"
                  @click.prevent="checkReferral"
                  :id="`apply` + kit.id"
                  class="btn-text btn-text-apply text-bold"
                >Apply</a>
                <a href="#" @click.prevent :id="`whatIsThis` + kit.id" class="btn-text text-bold">?</a>
              </div>
            </div>
          </div>

          <b-popover placement="bottom" triggers="click blur" :target="`notes` + kit.id">
            <div class="notesModal" v-if="kit">
              <div class="separator"></div>
              <div class="row">
                <div class="col-6">
                  <span class="title">Kit name</span>
                </div>
                <div class="col-6 text-right">
                  <a @click.prevent="toggleEdit" href="#">
                    <span v-if="editKit" @click.prevent="saveKitDetails">
                      <i class="fas fa-edit"></i> Save
                    </span>
                    <span v-else>
                      <i class="fas fa-edit"></i> Edit
                    </span>
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <span v-if="!editKit" :class="{ 'text-muted' : !kit.name }">{{ getKitName }}</span>
                  <input v-else v-model="kit.name" class="w-100" />
                </div>
              </div>
              <div class="separator"></div>
              <div class="row">
                <div class="col-12">
                  <span class="title">Notes</span>
                </div>
              </div>
              <div class="row">
                <div class="col-12" style="min-height: 100px;">
                  <span v-if="!editKit" :class="{ 'text-muted' : !kit.notes }">{{ getKitNotes }}</span>
                  <textarea v-else v-model="kit.notes" class="w-100 h-100"></textarea>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <span>Purchased: {{ purchaseDate }}</span>
                </div>
              </div>
              <div class="separator"></div>
              <div class="row">
                <div class="col-12">
                  <span>Kit ID: {{ kit.id }}</span>
                </div>
              </div>
              <div class="separator"></div>
            </div>
            <!--<textarea class="form-control" v-model="kit.notes"></textarea>-->
          </b-popover>
          <b-popover placement="bottom" triggers="click" :target="`apply` + kit.id">
            <div class="text-center" style="width:200px;" v-if="referral">
              <div>
                <div class="mb-2">
                  <strong>Practitioner Referral Code</strong>
                </div>
                <div
                  class="mb-2"
                >If you have been supplied a Practitioner Referral Code, please add it in here.</div>
                <div>
                  By using this Practitioner Referral Code, you acknowledge and consent to your results from the Microba Insight™ Report being disclosed to the practitioner associated with this referral code, in accordance with Microba’s
                  <a href="https://www.microba.com/terms/" target="_blank">Terms and Conditions</a>
                </div>
              </div>
              <div class="mt-3">
                {{ referral.name }} ({{ referral.referralCode }})
                <br />
                <br />
              </div>
              <a
                @click.prevent="applyReferral"
                :disabled="applingReferral"
                class="btn btn-outline-primary"
                href="#"
              >
                <span v-if="applingReferral">Applying code</span>
                <span v-else>Proceed</span>
              </a>
            </div>
            <div
              class="text-center"
              style="width:200px;"
              v-else-if="referralError"
            >{{ referralError }}</div>
            <div class="text-center" v-else>Loading...</div>
          </b-popover>
          <b-popover placement="bottom" triggers="click" :target="`whatIsThis` + kit.id">
            <div class="text-center" style="width:200px;">
              <strong class="text-bolder">Please note:</strong> If you have been supplied a Practitioner Referral Code, please add it in here -- this code starts with "REF".
            </div>
          </b-popover>
          <b-popover placement="bottom" triggers="click blur" :target="`timelineTop` + kit.id">
            <div class="p-2">
              <kit-timeline
                :kit="kit"
                :compactView="false"
                v-if="kit"
                :baseStatus="baseStatus"
                :overrideStatuses="overrideStatuses"
              ></kit-timeline>
            </div>
          </b-popover>
          <b-popover placement="bottom" triggers="click blur" :target="`timelineBottom` + kit.id">
            <div class="p-2">
              <kit-timeline
                :kit="kit"
                :compactView="false"
                v-if="kit"
                :baseStatus="baseStatus"
                :overrideStatuses="overrideStatuses"
              ></kit-timeline>
            </div>
          </b-popover>
        </div>
      </div>
    </div>
  </li>
</template>

<style lang="scss">
.kit-item {
  .rowA {
    border-top: 5px solid green;
    border-image-source: linear-gradient(to right, #8483bc, #469ec4);
    border-image-slice: 40;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 0px;
    padding: 2em;
  }

  .rowB {
    background: #f2f2f2;
    -webkit-box-shadow: inset 0px 5px 3px -2px rgba(0, 0, 0, 0.23);
    -moz-box-shadow: inset 0px 9px 5px -2px rgba(0, 0, 0, 0.23);
    box-shadow: inset 0px 9px 5px -2px rgba(0, 0, 0, 0.23);
  }

  .btn-text {
    position: absolute;
    top: 9px;
    right: 10px;
    color: #3f9fcf;
  }
  .btn-text-apply {
    right: 34px;
  }
  .text-bolder {
    font-weight: 800;
  }
}
.list-group {
  list-style: none;
  padding-left: 0;
}
</style>

<script>
import SurveyStat from '@/components/elements/SurveyStat'
import CoachState from '@/components/elements/CoachState'
import sampleStatus from '@/components/elements/sampleStatus'
import progressBar from '@/components/elements/progressBar'
import KitProgressBar from '@/components/elements/KitProgressBar'
import apiStringMappings from '@/mixins/apiStringMapping'
import KitTimeline from '@/components/elements/KitTimeline'
import { kitStatuses } from '@/enums/kitItemStatus'
import moment from 'moment'
import authService from '@/services/authService'
import qs from 'qs'

export default {
  name: 'kitItem',
  mixins: [apiStringMappings],
  components: {
    progressBar,
    sampleStatus,
    KitProgressBar,
    KitTimeline,
    SurveyStat,
    CoachState
  },
  props: [
    'project',
    'kit',
    'showCoach',
    'showReferralCode',
    'allowGive',
    'overrideStatuses',
    'baseStatus'
  ],
  data: () => {
    return {
      editKit: false,
      showModal: false,
      editingName: false,
      savingName: false,
      referralCode: '',
      referral: null,
      referralError: null,
      applingReferral: false,
      hidePlaceholder: false
    }
  },
  methods: {
    toggleEdit () {
      this.editKit = !this.editKit
    },
    checkReferral () {
      this.referral = null
      this.referralError = null

      if (this.referralCode.length < 1) {
        this.referralError = 'Please enter a referral code.'
      } else {
        this.$store
          .dispatch(
            'checkReferralCode',
            this.referralCode.replace('REF-', '').replace('REF', '')
          )
          .then(response => {
            this.referral = response.data
          })
          .catch(error => {
            this.referralError = error.response.data.message
          })
      }
    },
    applyReferral () {
      if (this.applingReferral) {
        return
      }

      this.applingReferral = true

      let payload = {
        id: this.kit.id,
        referralCode: this.referralCode.replace('REF-', '').replace('REF', '')
      }
      this.$store
        .dispatch('putKit', payload)
        .then(response => {
          this.$store.dispatch('getUserKits').then(res => {
            this.applingReferral = false
          })
          this.$store.dispatch('getSentKits')
        })
        .catch(error => {
          console.log(error)
          this.applingReferral = false
        })
    },
    removeReferral () {
      this.applingReferral = true

      let payload = {
        id: this.kit.id,
        referralCode: null
      }
      this.$store
        .dispatch('putKit', payload)
        .then(response => {
          this.$store.dispatch('getSentKits')
          this.$store.dispatch('getUserKits').then(res => {
            this.applingReferral = false
          })
        })
        .catch(error => {
          console.log(error)
          this.applingReferral = false
        })
    },
    editName () {
      this.editingName = true
    },
    saveName () {
      let payload = {
        id: this.kit.id,
        name: this.kit.name
      }
      this.$store
        .dispatch('putKit', payload)
        .then(success => {
          this.savingName = false
          this.editingName = false
          this.fetchSurveys()
        })
        .catch(error => {
          this.savingName = false
          this.editingName = false
          this.error = error
        })
    },
    saveKitDetails () {
      let payload = this.kit

      this.$store
        .dispatch('putKit', payload)
        .then(success => {
          this.fetchSurveys()
        })
        .catch(error => {
          this.error = error
        })
    },
    onClickProgress: function (type) {
      if (this.enableSurveys === false) return
      const slug = this.sampleToSlug(type)
      const route = `/surveys/${slug}/${this.kit.id}`
      this.$router.push(route)
    },
    onClickActivate: function () {
      this.$emit('onClickActivate')
    },
    onClickRedeem: function () {
      this.$emit('onClickRedeem')
    },
    onClickSend: function () {
      this.$emit('onClickRequest')
    },
    onClickGive: function () {
      this.$emit('onClickGive')
    },
    onClickPurchase: function () {
      this.$emit('onClickPurchase')
    },
    onClickReplacement: function () {
      this.$emit('onClickReplacement')
    },
    onClickCoachInfo: function () {
      this.$emit('onClickCoachInfo')
    },
    openQuestionnaire () {
      const surveyIds = qs.stringify([11, 12, 13])
      const questionnaireLink = `${process.env.MICROBA_QUESTIONNAIRE_URL}/questionnaireDashboard/${this.kit.surveyResultId}/${authService.getAccessToken()}/${surveyIds}`
      window.open(questionnaireLink, '_blank')
    }
  },
  computed: {
    isInfantKit () {
      return this.kit.surveyResultId && this.kit.surveyResultId !== null
    },
    surveyStats () {
      const disabledSurvey = [
        'INFANT_MEDICAL_HISTORY',
        'INFANT_DAY_OF_SAMPLING',
        'INFANT_DEMOGRAPHIC_AND_MILK_FEEDING'
      ]
      return this.kit.surveysStats.filter(
        survey => disabledSurvey.indexOf(survey.surveyType) === -1
      )
    },
    purchaseDate () {
      // return this.kit.activatedDate
      if (this.kit.redeemedDate) {
        return moment(this.kit.redeemedDate).format('MMMM Do')
      }
      if (this.kit.activatedDate) {
        return moment(this.kit.activatedDate).format('MMMM Do')
      }
      return ''
    },
    shortPHPrac () {
      if (this.hidePlaceholder) {
        return ''
      }
      return 'Add a Practitioner Referral Code'
    },
    fullPHPrac () {
      if (this.hidePlaceholder) {
        return ''
      }
      return 'Add a Practitioner Referral Code (starts with REF)'
    },
    getKitName () {
      if (this.kit.name) {
        return this.kit.name
      }
      return 'Add a kit name'
    },
    getKitNotes () {
      return this.kit.notes || 'Add notes...'
    },
    enableSurveys: function () {
      return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
    },
    dateString: function () {
      var dateKey = null
      if (this.kit.activatedDate) {
        dateKey = this.kit.activatedDate
      } else if (this.kit.redeemedDate) {
        dateKey = this.kit.redeemedDate
      } else {
        // If all date keys are empty - fall back to todays as a default.
        dateKey = new Date()
      }
      const theDate = moment(dateKey)
      const month = theDate.format('MMMM')
      const year = theDate.format('Y')
      return month + ' ' + year
    },
    reportLink: function () {
      return '/report/' + this.kit.sampleIdentifier
    },
    className: function () {
      const kitStatus = this.kit.kitStatus
        ? this.kit.kitStatus.toLowerCase().replace(/_/g, '-')
        : ''
      const sampleStatus = this.kit.sampleStatus
        ? this.kit.sampleStatus.toLowerCase().replace(/_/g, '-')
        : ''
      return kitStatus + ' ' + sampleStatus
    },
    unlocked: function () {
      // Check all answerd / total questions. If > 100 return true
      if (this.kit.surveysStats == null) return false
      const total = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.totalQuestions)
        return acc + val
      }, 0)
      const completed = this.kit.surveysStats.reduce((acc, el) => {
        const val = Number(el.completedQuestions)
        return acc + val
      }, 0)
      return (completed / total) * 100 >= 100
    },
    notActivated: function () {
      return (
        this.kit.kitStatus === 'UNASSIGNED' || this.kit.kitStatus === 'ASSIGNED'
      )
    },
    requestedReplacement: function () {
      return (
        this.kit.kitStatus !== 'REPLACED' &&
        (this.kit.sampleStatus === 'FAILED_OVERLOADED' ||
          this.kit.sampleStatus === 'FAILED_UNDERLOADED' ||
          this.kit.sampleStatus === 'FAILED_SWAB_OTHER')
      )
    },
    isInvalidated: function () {
      return this.kit.kitStatus === kitStatuses.INVALIDATED
    },
    isClientManagedResearchKit: function () {
      return this.project != null ? this.project.logisticType === 'CLIENT_MANAGED' : false
    }
  },
  mounted () {
    // if (this.kit.redeemedDate) {
    //   let kitTime = new Date(this.kit.redeemedDate).getTime()
    //   let OneDay = new Date().getTime() - (1 * 24 * 60 * 60 * 1000)
    //   console.log('One day', OneDay, kitTime, this.kit.redeemedDate)
    // } else {
    //   console.log('One day not redeemed')
    // }
  }
}
</script>

<style scoped lang='scss'>
a {
  cursor: pointer;
}
.text-bold {
  font-weight: 500;
}
.progress-wrap {
  margin-bottom: 0.2rem;
}

.kit-item {
  input.form-control {
    margin-bottom: 0.3em;
  }
  h2 {
    margin-bottom: 0em;
  }
  .btn-sm {
    margin: 0.2em 0px;
    padding: 0.2em;
    font-size: 14px;
    font-weight: normal;
  }
}

.notesModal {
  width: 350px;

  .separator {
    margin-top: 10px;
    margin-bottom: 10px;
    border-top: 2px solid rgba(151, 151, 151, 0.13);
  }
  .title {
    color: #3f9fcf;
    font-size: 16px;
    line-height: 30px;
  }
  a {
    color: #5cd69f;
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 30px;
    text-align: right;
  }
}
.pracCode {
  border: none;
  padding-bottom: 9px;
  padding-top: 9px;
  padding-left: 15px;
}

.sampleCodeCell {
  padding-top: 12px;
  padding-bottom: 3px;
}
.timelineCell {
  /*padding-top:12px;*/
}

.timeline {
  z-index: 0 !important;
}

/* The circles on the timeline */

.btn-timeline {
  /*padding-top:10px;*/
  /*margin-left: 270px;*/
}
</style>



// WEBPACK FOOTER //
// src/components/elements/KitItem.vue